import { render, staticRenderFns } from "./UserProfilesModal.vue?vue&type=template&id=48849c1c"
import script from "./UserProfilesModal.vue?vue&type=script&lang=js"
export * from "./UserProfilesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports